module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av744-59334eaaa3d7b487c4a2198608b48544.jpg";